/* Layout */
import Layout from '@/layout'

export const component = {
    '@/layout': Layout,
    // 首页
    '@/views/home/index': () => import('@/views/home/index'),
    // 飞行管理
    '@/views/tta': () => import('@/views/tta/index'),
    // 部门管理
    '@/views/department-manage/index': () => import('@/views/department-manage/index'),
    // 用户管理
    '@/views/user/user-manage': () => import('@/views/user/user-manage'),
    // 用户审核
    '@/views/user/user-review': () => import('@/views/user/user-review'),
    // 角色管理
    '@/views/role-manage/index': () => import('@/views/role-manage/index'),
    // 日志管理
    '@/views/log-manage/index': () => import('@/views/log-manage/index'),
    // 任务管理
    '@/views/task-manage/index': () => import('@/views/task-manage/index'),
    // 我的任务管理
    '@/views/task-manage/my-task': () => import('@/views/task-manage/my-task'),
    // 任务配置
    '@/views/task-manage/task-config': () => import('@/views/task-manage/task-config'),
    // 审批管理
    '@/views/approval-manage/index': () => import('@/views/approval-manage/index'),
    // 禁飞区管理
    '@/views/no-fly-zone-manage/index': () => import('@/views/no-fly-zone-manage/index'),
    // 禁飞区解禁申请
    '@/views/lift-ban/index': () => import('@/views/lift-ban/index'),
    // 全局电子围栏
    '@/views/global-fence/index': () => import('@/views/global-fence/index'),
    // 越界告警记录
    '@/views/boundary-alarm/index': () => import('@/views/boundary-alarm/index'),
    // 设备管理
    '@/views/device-manage/index': () => import('@/views/device-manage/index'),
    // 消息推送
    '@/views/news-push/index': () => import('@/views/news-push/index'),
    // 企业信息
    '@/views/corporate-information/index': () => import('@/views/corporate-information/index'),
}